import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getUserData = async (username) => {
  try {
    const response = await api.get(`/users/${username}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const updateUserPassword = async (username, oldPassword, newPassword) => {
  try {
    const response = await api.patch(
      `/users/${username}/password`,
      {
        oldPassword,
        newPassword,
      },
      {
        headers: setAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const getAllUsers = async (page, size) => {
  try {
    const response = await api.get(`/users`, {
      headers: setAuthHeader(),
      params: {
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createUser = async (userData) => {
  try {
    const response = await api.post(`/users`, userData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao criar usuário.');
  }
};

export const updateUser = async (username, userData) => {
  try {
    const response = await api.put(`/users/${username}`, userData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar usuário.');
  }
};

export const saveUserPreferences = async (username, preferences) => {
  try {
    const response = await api.patch(`/users/${username}/preferences`, preferences, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao salvar preferências do usuário.');
  }
};

export const updateUserPin = async (username, newPin, currentPin = null) => {
  try {
    const body = { newPin };
    if (currentPin !== null && currentPin !== undefined) {
      body.currentPin = currentPin;
    }
    const response = await api.put(`/users/${username}/pin`, body, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar PIN do usuário.');
  }
};

export const verifyPin = async (username, pin) => {
  try {
    const response = await api.get(`/users/${username}/pin/validate`, {
      headers: setAuthHeader(),
      params: {
        pin: pin,
      },
    });
    
    const data = response.data;
    
    if (!data) {
      throw new Error('PIN incorreto.');
    }
    
    if (data.isValid === false) {
      throw new Error('PIN incorreto.');
    }
    
    if (data.isValid === true) {
      return data;
    }
    
    throw new Error('PIN incorreto.');
  } catch (error) {
    if (error.message === 'PIN incorreto.') {
      throw error;
    }
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      if (errorData.isValid === false) {
        throw new Error('PIN incorreto.');
      }
      throw error.response.data;
    }
    throw new Error('PIN incorreto.');
  }
};

export const getPermissions = async (userId) => {
  try {
    const response = await api.get(`/permissions/${userId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar permissões do usuário.');
  }
};

export const savePermissions = async (userId, permissions) => {
  try {
    const response = await api.post(`/permissions/${userId}`, permissions, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao salvar permissões do usuário.');
  }
};